/**
 * Created by ostapenko.r on 9/29/2014.
 */


angular.module('flipto.components.fieldEditors')
    .config(['$provide', '$compileProvider', function ($provide, $compileProvider) {
            $compileProvider.directive('ftSelectField', [function () {
                return {
                    restrict: 'E',
                    scope: {
                        'disabledField': '=?',
                        'datasource': '=',
                        'items': '=',
                        'selectKey': '@',
                        'selectValue': '@'
                    },
                    templateUrl: '/app/components/field-editors/selectField.html',
                    link: function (scope, elem, attrs) {
                        scope.required = (angular.isDefined(attrs.required) && attrs.required !== 'false') || false;
                        scope.fields = adjustFields(scope.$eval(attrs.fields) || []);

                        /**
                         * Returns fields array as objects
                         * @param fields
                         * @returns {Array}
                         */
                        function adjustFields(fields) {
                            return _.map(fields, function (field) {
                                if (angular.isString(field) == true) {
                                    return {name: field, label: null};
                                }
                                return field;
                            });
                        }
                    }
                };
            }]);

    }]);